import type { ReactNode } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@nesso/ui/primitives/dialog';

import { MultiSelectDialogBody } from './multi-select-dialog/multi-select-dialog-body';
import type { MultiSelectOption } from './multi-select-option';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    options: MultiSelectOption[];
    selected: string[];
    onChange: (selected: string[]) => void;
    maxSelected?: number;
    groupOrder?: string[];
    searchPlaceholder?: string;
    notFoundMessage: string;
    deleteBadgeIcon: ReactNode;
    disabled?: boolean;
    loading: boolean;
    badgeClassName?: string;
    children: ReactNode;
};

export function MultiSelectDialog({ open, onOpenChange, title, children, ...body }: Props) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            {children}
            <DialogContent fullscreen className="p-0 gap-0">
                <DialogHeader className="text-left px-6 pt-6 pb-3">
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <MultiSelectDialogBody {...body} onOpenChange={onOpenChange} />
            </DialogContent>
        </Dialog>
    );
}
